import axios from 'axios'

const api = axios.create({
    // __prod__
    baseURL: 'https://api-dot-crdd-api.rj.r.appspot.com/api/'
})
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.get['Access-Control-Allow-Origin'] = '*';
export default api